import { render, staticRenderFns } from "./WineryWines_Desktop.vue?vue&type=template&id=17f25ea2&"
import script from "./WineryWines_Desktop.vue?vue&type=script&lang=js&"
export * from "./WineryWines_Desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports